module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGAAAABgBAMAAAAQtmoLAAAAJ1BMVEUAAAD///////////////////////////////////////////////+uPUo5AAAADXRSTlMAS/5aOwVhQiAYnZWe6Mk2ywAAAQhJREFUWMPt2DsKwkAUheELmuCjCgS0nnSpgiswO0gnttmBhb3uwMZeXEGW4NIk1Z8mMzmgkGKmC9yPk8fkDlyzVZ1NXvnNLKF+imhsuXva5HW+HO1+NWGd9lY/FLDOLWsUkGSWmbQiiCCCCOYPNtXwavEKgncxvDqUIbB1rjICnOvGACWFEQAfAdSgPYAicABQhfUAyqABQB3SA4gA+gERuAAgomdhQAQBXkAEAV5ABAFeQAQBfkBEYTLQb0l+aP21yh9O3xry5tO39z9+IOraXipNIO2p1GaICDcyIoRWSUS4GRPRae2+LcUDJf3M4IyLIIIIIvgtkIcI8phCHoTIoxZ5mCOPi75gcUZBBW+BogAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/header/header_close_h5.png
// module id = lDkP
// module chunks = 11